import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import TrendingProductsTable from 'widgets/economy/partials/TrendingProductsTable'
import TrendingProductsSmartview from 'widgets/economy/smartviews/TrendingProductsSmartview'

export default function TrendingProductsWidget ({
  limit = 5,
  product = ''
}) {
  return (
    <Widget>
      <Translator namespace='economy.trending_products'>
        <UI.Card paddingBottom={false} tight className='pt-4' overflow='hidden'>
          <UI.CardHeader withPadding withMargin={false}>
            {/*<UI.SecondaryHeading>*/}
            {/*  <Translation name={['titles', product].join('.')} />*/}
            {/*</UI.SecondaryHeading>*/}
            <UI.ButtonWrap>
              <MountSmartviewOnClick smartview={<TrendingProductsSmartview product={product} />} replace={false}>
                <UI.Button color='lightgray'>
                  <Translation name='generic.viewall' />
                </UI.Button>
              </MountSmartviewOnClick>
            </UI.ButtonWrap>
          </UI.CardHeader>
          <TrendingProductsTable product={product} limit={limit} />
        </UI.Card>
      </Translator>
    </Widget>
  )
}
